import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdjustments = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 9.5C11.2095 9.5 12.2186 10.3589 12.4502 11.5H14.5C14.7761 11.5 15 11.7239 15 12C15 12.2761 14.7761 12.5 14.5 12.5H12.4502C12.2186 13.6411 11.2095 14.5 10 14.5C8.78878 14.5 7.77856 13.6387 7.54883 12.4951C7.53268 12.4967 7.51656 12.5 7.5 12.5H1.5C1.22386 12.5 1 12.2761 1 12C1 11.7239 1.22386 11.5 1.5 11.5H7.5C7.51653 11.5 7.53271 11.5023 7.54883 11.5039C7.77892 10.3608 8.78911 9.5 10 9.5ZM10 10.5C9.17157 10.5 8.5 11.1716 8.5 12C8.5 12.8284 9.17157 13.5 10 13.5C10.8284 13.5 11.5 12.8284 11.5 12C11.5 11.1716 10.8284 10.5 10 10.5ZM6 1.5C7.21082 1.5 8.22003 2.3609 8.4502 3.50391C8.46662 3.50228 8.48314 3.5 8.5 3.5H14.5C14.7761 3.5 15 3.72386 15 4C15 4.27614 14.7761 4.5 14.5 4.5H8.5C8.48311 4.5 8.46665 4.49675 8.4502 4.49512C8.22039 5.63859 7.21115 6.5 6 6.5C4.79051 6.5 3.78142 5.64114 3.5498 4.5H1.5C1.22386 4.5 1 4.27614 1 4C1 3.72386 1.22386 3.5 1.5 3.5H3.5498C3.78142 2.35886 4.79051 1.5 6 1.5ZM6 2.5C5.17157 2.5 4.5 3.17157 4.5 4C4.5 4.82843 5.17157 5.5 6 5.5C6.82843 5.5 7.5 4.82843 7.5 4C7.5 3.17157 6.82843 2.5 6 2.5Z",
		fill: "currentColor"
	})
});
export default SvgAdjustments;
